module.exports = __webpack_public_path__ + "static/img/DIYStep4.6e733dbb.jpg";